import {
  CriteriaWithPagination,
  EuiBasicTable,
  EuiBasicTableColumn,
  EuiButtonIcon,
  EuiComboBox,
  EuiFlexGroup,
  EuiFlexItem,
  EuiFormRow,
  EuiHealth,
  EuiLink,
  EuiSpacer,
  EuiTableSelectionType,
  Pagination,
  euiPaletteColorBlindBehindText,
} from "@elastic/eui";
import {
  Box,
  Divider,
  List,
  Menu,
  NumberFormatter,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import { useEffect, useState } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  isNullOrEmpty,
  isNullOrUndefined,
  isNullOrUndefinedArry,
} from "../../../_base/extension/StringExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { ParamSearchBase } from "../../../_base/model/_base/ParamSearchBase";
import AppAction from "../../../common/AppAction";
import AppSearch from "../../../common/AppSearch";
import { API_ROUTE } from "../../../const/apiRoute";
import { MessageResponse } from "../../../model/MessageResponse";
import CreateView from "./CreateView";
import DeleteView from "./DeleteView";
import EditView from "./EditView";
import { useLocation, useNavigate } from "react-router-dom";
import { WarranteeSamsung } from "../../../model/TblWarranteeSamsung";
import moment from "moment";
import * as xlsx from "xlsx";
import { getAllWarranteeSamsung } from "../../../api/ApiWarranteeSamsung";

const visColorsBehindText = euiPaletteColorBlindBehindText();

const optionSearch = {
  isActive: [
    {
      value: true,
      label: "Kích hoạt",
      "data-test-subj": "titanOption",
      color: visColorsBehindText[0],
    },
    {
      value: false,
      label: "Chưa kích hoạt",
      color: visColorsBehindText[1],
    },
  ],

  status: [
    {
      value: "N",
      label: "New",
      "data-test-subj": "titanOption",
      color: visColorsBehindText[0],
    },
    {
      value: "S",
      label: "Success",
      "data-test-subj": "titanOption",
      color: visColorsBehindText[0],
    },
    {
      value: "E",
      label: "Error",
      "data-test-subj": "titanOption",
      color: visColorsBehindText[0],
    },
  ],
};

const WarranteeSamsungList = () => {
  const location = useLocation();
  const sessionId = location.state && location.state.id;

  const columns: Array<EuiBasicTableColumn<WarranteeSamsung>> = [
    {
      field: "id",
      name: "Id",
      sortable: true,
      truncateText: true,
      width: "2%",
    },
    {
      field: "",
      name: "Khách hàng",
      sortable: true,
      truncateText: true,
      width: "12%",
      render: (online: WarranteeSamsung) => (
        <Box>
          <Text fw={500}>Họ tên: {online.tenKhachHang}</Text>
          <Text>Sđt: {online.sdtKhachHang}</Text>
        </Box>
      ),
    },
    {
      field: "",
      name: "Sản phẩm",
      sortable: true,
      truncateText: true,
      render: (online: WarranteeSamsung) => (
        <Box>
          <Text>
            Tên sản phẩm: <EuiLink target="_blank">{online.tenVatTu}</EuiLink>
          </Text>
          <Text>Mã sản phẩm: {online.maVatTu}</Text>
          <Text>Mã vạch: {online.maVach}</Text>
          <Text>Đơn vị tính: {online.donViTinh}</Text>
          <Text>Nhà cung cấp: {online.maNhaCungCap}</Text>
          <Text>Mã kho: {online.maKho}</Text>
        </Box>
      ),
    },
    {
      field: "",
      name: "Chứng từ",
      sortable: true,
      truncateText: true,
      width: "12%",
      render: (online: WarranteeSamsung) => (
        <Box>
          <Text>Số chứng từ: {online.soChungTu}</Text>
          <Text>Mã chứng từ: {online.maChungTu}</Text>
          <Text>
            Ngày chứng từ: {moment(online.ngayChungTu).format("DD-MM-YYYY")}
          </Text>
        </Box>
      ),
    },
    {
      field: "",
      name: "Trạng thái",
      sortable: true,
      truncateText: true,
      width: "12%",
      render: (online: WarranteeSamsung) => (
        <Box>
          <Text>Ngày kích hoạt: {online.activationDate}</Text>
        </Box>
      ),
    },
    {
      field: "responseMessage",
      name: "Response Message",
      sortable: true,
      truncateText: true,
      width: "12%",
      render: (responseMessage: string) => (
        <Tooltip label={responseMessage}>
          <p>{responseMessage}</p>
        </Tooltip>
      ),
    },
    {
      field: "sendStatus",
      name: "Trạng thái",
      sortable: true,
      truncateText: true,
      width: "5%",
      render: (status: string, collection: WarranteeSamsung) => (
        <EuiHealth color={getStatusColor(status)}>
          {status === "N"
            ? "New"
            : status === "E"
            ? "Error"
            : status === "S"
            ? "Success"
            : "Chờ duyệt"}
        </EuiHealth>
      ),
    },
    {
      name: "Actions",
      width: "5%",
      render: (online: WarranteeSamsung) => {
        return (
          <>
            <EuiFlexGroup
              responsive={true}
              wrap={false}
              gutterSize="s"
              alignItems="center"
            >
              <EuiFlexItem grow={false}>
                <EuiButtonIcon
                  disabled={online.sendStatus === "S" ? true : false}
                  iconType="documentEdit"
                  aria-label="Dashboard"
                  color="success"
                  onClick={(e: any) => {
                    if (isNullOrUndefined(online))
                      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                    else {
                      editItem(online.id);
                    }
                  }}
                />
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
                <EuiButtonIcon
                  disabled={online.sendStatus === "S" ? true : false}
                  iconType="trash"
                  color="danger"
                  onClick={(e: any) => {
                    if (isNullOrUndefined(online))
                      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                    else {
                      deleteItem([online.id]);
                    }
                  }}
                />
              </EuiFlexItem>
            </EuiFlexGroup>
          </>
        );
      },
    },
  ];

  const getStatusColor = (status: any) => {
    switch (status) {
      case "E":
        return "red";
      case "S":
        return "green";
      case "N":
        return "yellow";
      default:
        return "subdued";
    }
  };

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [pagination, setPagination] = useState<Pagination>(paginationBase);
  const [selectedOptions, setSelected] = useState();
  const [selectedSearch, setSelectedSearch] = useState<{
    isActive: any[];
    status: any[];
  }>({
    isActive: [],
    status: [],
  });
  const [paramSearch, setParamSearch] = useState<ParamSearchBase>();
  const [isSelectedItem, setSelectedItems] = useState<any[]>([]);
  const [datas, setDatas] = useState<WarranteeSamsung[]>([]);
  const [total, setTotal] = useState(0);

  const handleEditData = async (id: number) => {
    if (id) {
      editItem(id);
    } else {
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    }
  };

  const onTableChange = async ({
    page: { index, size },
  }: CriteriaWithPagination<any>) => {
    setPagination({
      ...pagination,
      pageIndex: index,
      pageSize: size,
      totalItemCount: 1000,
    });
  };

  const onChange = (selectedOptions: any) => {
    setSelected(selectedOptions);
    if (!isNullOrUndefinedArry(selectedOptions)) {
      const value = selectedOptions[0].value;
      if (!isNullOrUndefined(value))
        setParamSearch({ ...paramSearch, inActive: value });
    } else setParamSearch({ ...paramSearch, inActive: undefined });
  };

  const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
    const key = event.target.value;
    if (!isNullOrUndefined(key))
      setParamSearch({ ...paramSearch, keyWord: key });
  };

  const handleChangeSearch = (value: any[], key: string) => {
    setSelectedSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  const onSelectionChange = (selectedItems: any[]) => {
    setSelectedItems(selectedItems);
  };
  const selection: EuiTableSelectionType<any> = {
    selectable: (user: any) => true,
    selectableMessage: (selectable: boolean) =>
      !selectable ? "User is currently offline" : "",
    onSelectionChange,
  };

  const openModal = () =>
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Thêm mới yêu cầu bảo hành</Title>
          </div>
        </>
      ),
      children: (
        <CreateView
          sessionId={sessionId || null}
          onSearch={() =>
            fetchDataWarranteeSamsung(
              pagination.pageIndex,
              pagination.pageSize,
              paramSearch?.keyWord,
              paramSearch?.inActive
            )
          }
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  const openModalEdit = () => {
    if (
      isSelectedItem &&
      (isSelectedItem.length < 1 || isSelectedItem.length > 1)
    )
      NotificationExtension.Warn("Xin vui lòng chọn 1 đơn để chỉnh sửa !");
    else {
      editItem(isSelectedItem[0].id);
    }
  };

  const openModalDelete = () => {
    if (isSelectedItem && isSelectedItem.length < 1)
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    else {
      const ids = isSelectedItem;
      deleteItem(ids.map((item) => item?.id));
    }
  };

  const openExportExcel = async () => {
    debugger;
    try {
      const dataAll = await getAllWarranteeSamsung(`?SessionId=${sessionId}`);
      const worksheet = xlsx.utils.json_to_sheet(dataAll.data);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Data");
      xlsx.writeFile(workbook, "danh-sach-bao-hanh-samsung.xlsx");
      NotificationExtension.Success("Export excel thành công");
    } catch (error) {
      NotificationExtension.Fails("Export excel thất bại");
    }
  };

  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa yêu cầu bảo hành</Title>
        </>
      ),
      children: (
        <DeleteView
          onSearch={() =>
            fetchDataWarranteeSamsung(
              pagination.pageIndex,
              pagination.pageSize,
              paramSearch?.keyWord,
              paramSearch?.inActive
            )
          }
          idItem={idItem}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(id: number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa yêu cầu bảo hành!</Title>
        </>
      ),
      children: (
        <EditView
          id={id}
          onSearch={() =>
            fetchDataWarranteeSamsung(
              pagination.pageIndex,
              pagination.pageSize,
              paramSearch?.keyWord,
              paramSearch?.inActive
            )
          }
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const elementSearch = [
    <Menu.Item closeMenuOnClick={false}>
      <EuiFormRow label="Trạng thái ">
        <EuiComboBox
          aria-label="Accessible screen reader label"
          placeholder="Chọn..."
          options={optionSearch.isActive}
          selectedOptions={selectedSearch?.isActive}
          onChange={(e) => handleChangeSearch(e, "isActive")}
          fullWidth={true}
          isDisabled={loading}
          singleSelection={{ asPlainText: true }}
          isCaseSensitive
        />
      </EuiFormRow>
    </Menu.Item>,
  ];

  const fetchDataWarranteeSamsung = async (
    index: number,
    size?: number,
    keyWord?: string,
    inActive?: boolean
  ) => {
    setLoading(true);

    setError(undefined);
    const repository = new Repository(
      process.env.REACT_APP_Auth_APP_API_CUST_PRIVIEGE
    );
    try {
      let urlSearch = `${API_ROUTE.GET_LIST_WARRANTEE_SAMSUNG}?Skip=${
        index * (size ?? 0)
      }&Take=${size}&SessionId=${sessionId}`;
      if (!isNullOrEmpty(keyWord))
        urlSearch = urlSearch + `&KeySearch=` + keyWord;
      // if (!isNullOrUndefined(inActive))
      //   urlSearch = urlSearch + `&Active=` + inActive;
      if (
        selectedSearch &&
        selectedSearch.status &&
        selectedSearch.status.length > 0
      ) {
        selectedSearch.status.map(
          (status) => (urlSearch += `&Status=${status.value}`)
        );
      }

      let callapi = await repository.get<MessageResponse<any>>(urlSearch);
      if (
        isNullOrUndefined(callapi) ||
        isNullOrUndefinedArry(callapi?.data.lists)
      ) {
        setTotal(0);
        setDatas([]);
      } else {
        setDatas(callapi?.data.lists ?? []);
        setPagination({
          ...pagination,
          totalItemCount: callapi?.data.count ?? 0,
        });
        setTotal(callapi?.data.count ?? 0);
      }
      return callapi?.data;
    } catch (error: any) {
      setError("Có lỗi xảy ra khi tải dữ liệu !");
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchDataWarranteeSamsung(
        pagination.pageIndex,
        pagination.pageSize,
        paramSearch?.keyWord,
        paramSearch?.inActive
      );
    };
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  return (
    <>
      <AppAction
        openModal={openModal}
        openModalDelete={openModalDelete}
        openModalEdit={openModalEdit}
        openExportExcel={openExportExcel}
      ></AppAction>
      <Divider my="sm" />
      <AppSearch
        loading={loading}
        onChange={onChange}
        onChangeText={onChangeText}
        onSearch={() =>
          fetchDataWarranteeSamsung(
            pagination.pageIndex,
            pagination.pageSize,
            paramSearch?.keyWord,
            paramSearch?.inActive
          )
        }
        elementSearch={elementSearch}
      />
      <EuiSpacer size="l" />
      <EuiBasicTable
        tableCaption="Demo of EuiDataGrid with selection"
        items={datas ? datas : []}
        itemId="id"
        error={error}
        loading={loading}
        noItemsMessage={"Không có dữ liệu"}
        selection={selection}
        columns={columns}
        pagination={pagination}
        isSelectable={true}
        hasActions={true}
        responsive={true}
        onChange={onTableChange}
        compressed={true}
      />
    </>
  );
};

export default WarranteeSamsungList;
